import { render, staticRenderFns } from "./HomeSugal.vue?vue&type=template&id=5901cc96&"
import script from "./HomeSugal.vue?vue&type=script&lang=ts&"
export * from "./HomeSugal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5901cc96', component.options)
    } else {
      api.reload('5901cc96', component.options)
    }
    module.hot.accept("./HomeSugal.vue?vue&type=template&id=5901cc96&", function () {
      api.rerender('5901cc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Sugal/HomeSugal.vue"
export default component.exports